var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("DialogLayout", {
    attrs: { title: _vm.title, visible: _vm.dialogVisible, width: "45em" },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      open: _vm.open
    },
    scopedSlots: _vm._u([
      {
        key: "form",
        fn: function() {
          return [
            _c("CreateForm", {
              ref: "createForm",
              attrs: { action: "/create-merge-data", billingYmMode: "this" },
              model: {
                value: _vm.createFormModel,
                callback: function($$v) {
                  _vm.createFormModel = $$v
                },
                expression: "createFormModel"
              }
            })
          ]
        },
        proxy: true
      },
      {
        key: "footer",
        fn: function() {
          return [_c("CreateDialogFooter", { on: { create: _vm.clickCreate } })]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }